import { ref, computed, watch } from "vue";

const STORAGE_KEY = "portfolio-theme";
const theme = ref("dark");
let initialized = false;

function getPreferredTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (_) {
    /* ignore */
  }
  if (typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: light)").matches) {
    return "light";
  }
  return "dark";
}

function applyTheme(value) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", value);
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (_) {
    /* ignore */
  }
}

export function initTheme() {
  if (initialized) return theme;
  theme.value = getPreferredTheme();
  applyTheme(theme.value);
  initialized = true;

  if (typeof window !== "undefined") {
    const media = window.matchMedia("(prefers-color-scheme: light)");
    const onChange = (e) => {
      try {
        if (localStorage.getItem(STORAGE_KEY)) return;
      } catch (_) {
        return;
      }
      theme.value = e.matches ? "light" : "dark";
      applyTheme(theme.value);
    };
    if (media.addEventListener) media.addEventListener("change", onChange);
    else if (media.addListener) media.addListener(onChange);
  }

  return theme;
}

export function useTheme() {
  if (!initialized) initTheme();

  const isDark = computed(() => theme.value === "dark");
  const isLight = computed(() => theme.value === "light");

  const setTheme = (value) => {
    if (value !== "light" && value !== "dark") return;
    theme.value = value;
    applyTheme(value);
  };

  const toggleTheme = () => {
    setTheme(theme.value === "dark" ? "light" : "dark");
  };

  watch(theme, (value) => applyTheme(value));

  return {
    theme,
    isDark,
    isLight,
    setTheme,
    toggleTheme,
  };
}
